import LevelOverviewSection from './LevelOverviewSection'
import CategoryCardGrid from './CategoryCardGrid'
import { HEADER_IMAGES } from './constants'
import {
  HeaderRow,
  HeaderLeft,
  Avatar,
  NameColumn,
  UserName,
  DateRow,
  CalendarIcon,
  DateText,
} from './styled-components'
import useGamification from './useGamification'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectHomeData } from '@/containers/HomePage/HomeSelectors'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { Card } from '@/shared/theme/styled-components'

const Gamification = () => {
  const { t } = useTranslation()
  const { userAchievements = [] } = useSelector(selectHomeData)
  const { isExternal } = useSelector(selectAuthData)
  const { categories, levelSummaries, firstname, name, createdAt } = useGamification({
    userAchievements,
  })

  if (isExternal) {
    return null
  }

  return (
    <Card>
      <HeaderRow>
        <HeaderLeft>
          <Avatar src={HEADER_IMAGES.avatar} alt='Avatar' />
          <NameColumn>
            <UserName>
              {firstname} {name}
            </UserName>
            <DateRow>
              <CalendarIcon src={HEADER_IMAGES.calendarIcon} alt='' />
              <DateText>{createdAt ? new Date(createdAt).toLocaleDateString() : t('common:not_available')}</DateText>
            </DateRow>
          </NameColumn>
        </HeaderLeft>
      </HeaderRow>

      <LevelOverviewSection levelSummaries={levelSummaries} categories={categories} />
      <CategoryCardGrid categories={categories} />
    </Card>
  )
}

export default Gamification
